import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AiAssistantAdminLayout } from "@/components/admin/ai-assistant/ai-assistant-admin-layout";
import { protectedRouteMiddleware } from "../../../middleware/authMiddleware";

export const Route = createFileRoute("/admin/ai-assistant")({
	beforeLoad: protectedRouteMiddleware,
	component: () => (
		<AiAssistantAdminLayout>
			<Outlet />
		</AiAssistantAdminLayout>
	),
});
